





















































































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, CompleteRouteRequest } from '@/types/request';
import ConfirmationBox from '../../components/ConfirmationBox.vue';
import { required, minValue, integer, maxValue } from 'vuelidate/lib/validators';
import { ServiceRequest } from '@/types/entity';
import { DateUtils } from '@/util/dateUtils';

@Component({
    props: {
        requestId: String,
        routeId: String,
    },
    mixins: [validationMixin],
    components: {
        ConfirmationBox,
    },
    data() {
        return {
            driverToWait: null,
            wasAnyAdditionalPassangers: null,
            additionalPassangers: null,
            wasHomeAssistanceRequired: null,
            additionalNotes: '',
            noShow: null,
            wasBariatricServiceRequired: null,
            waitingTime: {
                hours: 0,
                minutes: 0,
            },
            rxStop: null,
            rxStopWait: null,
            rxWaitingTime: {
                minutes: 0,
            },
        };
    },
    validations() {
        const validations = {
            driverToWait: {
                required,
            },
            wasAnyAdditionalPassangers: {
                required,
            },
            additionalPassangers: {
                required,
                integer,
                minValue: minValue(1),
            },
            wasHomeAssistanceRequired: {
                required,
            },
            noShow: {
                required,
            },
            wasBariatricServiceRequired: {
                required,
            },
            waitingTime: {
                required,
                hours: {
                    required,
                    integer,
                    minValue: minValue(0),
                    maxValue: maxValue(24),
                },
                minutes: {
                    required,
                    integer,
                    minValue: minValue(0),
                    maxValue: maxValue(60),
                },
            },
            rxStop: {
                required,
            },
            rxStopWait: {
                required,
            },
            rxWaitingTime: {
                required,
                minutes: {
                    required,
                    integer,
                    minValue: minValue(0),
                    maxValue: maxValue(60),
                },
            },
        };
        if (!this.$data.wasAnyAdditionalPassangers) {
            delete validations.additionalPassangers;
        }
        if (!this.$data.driverToWait) {
            delete validations.waitingTime;
        }
        if (!this.$data.rxStopWait) {
            delete validations.rxWaitingTime;
        }
        if (!this.$data.rxStop) {
            delete validations.rxStopWait;
            delete validations.rxWaitingTime;
        }
        return validations;
    },
})
export default class CompleteRouteModal extends Vue {
    private show = true;
    private showConfirmBox = false;
    private isValidWaitingTime = true;
    private isRxValidWaitingTime = true;
    private serviceRequest: ServiceRequest | any = '';

    private validateWaitingTime() {
        if (this.$data.driverToWait) {
            this.isValidWaitingTime = true;
        } else {
            this.isValidWaitingTime = false;
            this.$data.waitingTime.hours = 0;
            this.$data.waitingTime.minutes = 0;
        }
        if (this.$data.rxStopWait) {
            this.isRxValidWaitingTime = true;
        } else {
            this.isRxValidWaitingTime = false;
            this.$data.rxWaitingTime.minutes = 0;
        }
        if ((this.$data.waitingTime.hours > 0 || this.$data.waitingTime.minutes > 0) && this.$data.driverToWait) {
            this.isValidWaitingTime = false;
        }
        if ((this.$data.rxWaitingTime.minutes > 0) && this.$data.rxStopWait) {
            this.isRxValidWaitingTime = false;
        }
    }

    private async getRequestDetails() {
        const id = this.$props.id || this.$route.params.id;
        const response = await ObjectFactory.getRequestService().getRequestDetails(id, this.$store.state.serverUrl);
        this.serviceRequest = response.data;
    }

    private async completeRequest(requestId: string, routeId: string) {
        const id = this.$props.id || this.$route.params.id;
        const completeRequest: CompleteRouteRequest = {
            additionalNotes: this.$data.additionalNotes,
            requestId: this.$props.requestId,
            noOfAdditionalPassangers: this.$data.wasAnyAdditionalPassangers ? this.$data.additionalPassangers : 0,
            noShow: this.$data.noShow,
            waitingTime: 0,
            wasHomeAssistanceRequired: this.$data.wasHomeAssistanceRequired,
            wasBariatricServiceRequired: this.$data.wasBariatricServiceRequired,
        };
        if (this.isValidWaitingTime) {
            completeRequest.waitingTime = DateUtils.convertMinutesToMillis(this.$data.waitingTime.minutes) +
                DateUtils.convertMinutesToMillis(this.$data.waitingTime.hours * 60);
        }
        const request: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: completeRequest,
            url: `${MedTransGoConstants.HTTP_URL_ROUTES}/${routeId}/complete`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await ObjectFactory.getHttpService().put<string>(request);
        if (response.success) {
            await this.getRequestDetails();
            if (this.serviceRequest.status === 'Completed') {
                this.$router.push({
                    path: `${MedTransGoConstants.URL_REQUESTS}/${id}`,
                    query: { requestType: this.serviceRequest.deliveryRequest ? 'deliveryRequest' :
                        'transportRequest', status: 'Completed' },
                });
                this.close();
            } else {
                this.close();
            }
        }
    }

    private close() {
        this.$emit('close');
    }
}
